import './acesso-paineis.css';
import { PainelOutput } from '../../../services/PainelService';

interface AcessoPessoalProps {
  checkedLista: (value: any) => void
  listaPaineis?: any[];
  paineisComAcesso?: PainelOutput[];
}

const AcessoPaineis = ({ checkedLista, listaPaineis, paineisComAcesso }: AcessoPessoalProps) => {

  return (
    <fieldset className='acesso-paineis--container'>
      <div className='acesso-paineis--titulo'>
        <label> <strong>Permitir acessos aos Paineis</strong> </label>
      </div>
      <div className='acesso-paineis--lista'>
        {listaPaineis!.map((painel, index) => (
          <div
            className={`row${index === listaPaineis!.length - 1 ? '-ultima' : ''}`}
            key={painel['id']}>
            <input
              type="checkbox"
              id={painel['id']}
              checked={paineisComAcesso?.some((item) => item.id === painel.id)}
              onChange={() => checkedLista?.(painel)}
            />
            <label 
              onClick={() => checkedLista?.(painel)}
              htmlFor={painel['nome']}>{painel['nome']}</label>
          </div>
        ))}
      </div>
    </fieldset>
  );
};

export default AcessoPaineis;
